import { render } from "./UpdateArtistForm.vue?vue&type=template&id=2e58abec"
import script from "./UpdateArtistForm.vue?vue&type=script&lang=js"
export * from "./UpdateArtistForm.vue?vue&type=script&lang=js"

import "./UpdateArtistForm.vue?vue&type=style&index=0&id=2e58abec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__